

import React, { useEffect, useState } from 'react'
import allowanceService from '../Services/allowanceService';

const AllowanceCard = () => {
  const [totalAllowance, setTotalAllowance] = useState(0);
  const [travelAllowance, setTravelAllowance] = useState(0);
  const [otherAllowance, setOtherAllowance] = useState(0);
  const statsData = [
    {
      id: 1,
      value: `₹${totalAllowance.toLocaleString()}`,
      label: "Total Allowance",
      bgColor: "bg-[#D2FAEC]"
    },
    {
      id: 2,
      value: `₹${travelAllowance.toLocaleString()}`,
      label: "Travel Allowance",
      bgColor: "bg-[#D3EEFF]"
    },
    {
      id: 3,
      value: `₹${otherAllowance.toLocaleString()}`,
      label: "Other Allowance",
      bgColor: "bg-[#FFDDC0]"
    }
  ]

  const fetchAllowanceCount = async () => {
    try {
      const response = await allowanceService.getAllowanceDashboardCount();
      const data = response.data;
      setTotalAllowance(data.totalAllowances || 0);
      setTravelAllowance(data.travelAllowanceTotal || 0);
      setOtherAllowance(data.otherAllowanceTotal || 0);
      
    } catch (error) {
      console.error('Error fetching allowance pending count:', error);
    }
  }

  useEffect(() => {
    fetchAllowanceCount();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 h-[129px] gap-5 mb-8">
      {statsData.map(stat => (
        <div 
          key={stat.id} 
          className={`${stat.bgColor} rounded-xl p-6 shadow-sm border border-gray-100`}
        >
          <div className="text-3xl font-bold text-gray-800 mb-2">
            {stat.value}
          </div>
          <div className="text-sm text-gray-600 font-medium">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  )
}

export default AllowanceCard